// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"e27ab06b","903":"eb7c1e4a","905":"b3d3f8e7"}[chunkId] + ".chunk.js";
};